import React from 'react';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Navigate } from 'react-router';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

export default class DailyWorkReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            records: [],
            fromDate: null,
            toDate: null,
            users: [],
            selectedUserIds: [],
            expandedTaskId: null   // برای کنترل باز شدن جزئیات
        };
    }

    componentDidMount() {
        this.httpPost('api/v1/user/list', { page: 1, count: 200, phrase: '', filters: {} })
            .then(data => {
                if (data.status === 1) this.setState({ users: data.records || [], data: data, loading: false });
            })
            .catch(() => { });
    }

    toISODate(dateObj) {
        if (!dateObj) return null;
        return dateObj.toDate().toISOString();
    }

    loadReport = () => {
        this.setState({ loading: true, expandedTaskId: null });
        this.httpPost('api/v1/report/daily-work', {
            fromDate: this.toISODate(this.state.fromDate),
            toDate: this.toISODate(this.state.toDate),
            userIds: this.state.selectedUserIds.length > 0 ? this.state.selectedUserIds : null
        }).then(data => {
            if (data.status === 1) {
                this.setState({ records: data.records, loading: false, data });
            } else {
                this.showErorrMessage(data.message);
                this.setState({ loading: false });
            }
        });
    };

    toggleUser(userId) {
        const arr = [...this.state.selectedUserIds];
        const idx = arr.indexOf(userId);
        if (idx > -1) arr.splice(idx, 1);
        else arr.push(userId);
        this.setState({ selectedUserIds: arr });
    }

    toggleTaskDetails = (taskId) => {
        this.setState(prev => ({
            expandedTaskId: prev.expandedTaskId === taskId ? null : taskId
        }));
    };

    // چاپ حرفه‌ای
    printReport = () => {
        const { records, fromDate, toDate } = this.state;
        let html = `<html><head><title>گزارش کار روزانه</title>
            <style>
                body { font-family: Tahoma, sans-serif; direction: rtl; padding: 20px; font-size: 9pt; }
                table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                th, td { border: 1px solid #000; padding: 5px 8px; text-align: center; }
                th { background: #eee; }
                h2, h3 { text-align: center; }
                .sub-table { width: 95%; margin: 10px auto; }
                .sub-table th, .sub-table td { font-size: 8pt; }
            </style></head><body>
            <h2>گزارش کار روزانه</h2>
            <p>بازه: ${fromDate?.format?.('jYYYY/jMM/jDD') || '---'} تا ${toDate?.format?.('jYYYY/jMM/jDD') || '---'}</p>`;

        records.forEach((r, i) => {
            html += `<h3>${i + 1}. ${r.title} – مجری: ${r.assignedTo} – مشتری: ${r.customerName}</h3>
            <table><tr><th>وضعیت</th><td>${r.statusText}</td><th>مدت زمان</th><td>${r.duration}</td></tr></table>`;
            html += `<p><strong>مشتری:</strong> ${r.customerName} | <strong>وضعیت:</strong> ${r.statusText} | <strong>مدت زمان:</strong> ${r.duration}</p>`;
            if (r.comments && r.comments.length > 0) {
                html += `<h4>مکاتبات (${r.comments.length})</h4><table class="sub-table">
                    <tr><th>کاربر</th><th>متن</th><th>تاریخ</th></tr>`;
                r.comments.forEach(c => {
                    html += `<tr><td>${c.userName}</td><td>${c.content}</td><td>${c.createdDatePersian}</td></tr>`;
                });
                html += `</table>`;
            }
            if (r.documents && r.documents.length > 0) {
                html += `<h4>مدارک (${r.documents.length})</h4><table class="sub-table">
                    <tr><th>نام فایل</th><th>نوع</th><th>توضیح</th><th>تاریخ</th></tr>`;
                r.documents.forEach(d => {
                    html += `<tr><td>${d.fileName}</td><td>${d.documentType}</td><td>${d.description}</td><td>${d.uploadDatePersian}</td></tr>`;
                });
                html += `</table>`;
            }
            html += `<hr>`;
        });
        html += `</body></html>`;
        const win = window.open('', '_blank');
        win.document.write(html);
        win.document.close();
        setTimeout(() => win.print(), 300);
    };

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
    
        const { loading, records, fromDate, toDate, users, selectedUserIds, expandedTaskId } = this.state;
        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={this.state.data} />,
            <div className="nk-content" key="content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="page-title">گزارش کار روزانه</h3>
                                    </div>
                                    {records.length > 0 && (
                                        <div className="nk-block-head-content">
                                            <button className="btn btn-outline-info" onClick={this.printReport}>
                                                <em className="icon ni ni-printer"></em> چاپ گزارش
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* فیلترها */}
                            <div className="card card-bordered mb-3">
                                <div className="card-inner">
                                    <div className="row g-3 align-items-end">
                                        <div className="col-md-2">
                                            <label className="form-label">از تاریخ</label>
                                            <DatePicker calendar={persian} locale={persian_fa}
                                                value={fromDate} onChange={d => this.setState({ fromDate: d })}
                                                format="YYYY/MM/DD" inputClass="form-control" />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">تا تاریخ</label>
                                            <DatePicker calendar={persian} locale={persian_fa}
                                                value={toDate} onChange={d => this.setState({ toDate: d })}
                                                format="YYYY/MM/DD" inputClass="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">کاربران (اختیاری)</label>
                                            <div style={{ maxHeight: '100px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: 6, padding: 6 }}>
                                                {users.map(u => (
                                                    <label key={u.id} style={{ marginLeft: 12 }}>
                                                        <input type="checkbox" checked={selectedUserIds.includes(u.id)} onChange={() => this.toggleUser(u.id)} />
                                                        {' '}{u.fullName}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <button className="btn btn-primary" onClick={this.loadReport}>دریافت گزارش</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* جدول اصلی */}
                            <div className="card card-bordered card-stretch">
                                {loading ? this.renderLoading() : (
                                    records.length > 0 ? (
                                        <div className="card-inner p-0">
                                            <table className="table table-bordered table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>ردیف</th>
                                                        <th>عنوان وظیفه</th>
                                                        <th>مجری</th>
                                                        <th>مشتری</th>
                                                        <th>وضعیت</th>
                                                        <th>مدت زمان</th>
                                                        <th>جزئیات</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {records.map((r, idx) => (
                                                        <React.Fragment key={r.id}>
                                                            <tr onClick={() => this.toggleTaskDetails(r.id)} style={{ cursor: 'pointer' }}>
                                                                <td>{idx + 1}</td>
                                                                <td>{r.title}</td>
                                                                <td>{r.assignedTo}</td>
                                                                <td>{r.customerName}</td>
                                                                <td>{r.statusText}</td>
                                                                <td>{r.duration}</td>
                                                                <td>
                                                                    <button className="btn btn-sm btn-light">
                                                                        {expandedTaskId === r.id ? 'بستن' : 'مشاهده'}
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                            {expandedTaskId === r.id && (
                                                                <tr>
                                                                    <td colSpan="7" >
                                                                        <div className="p-3">
                                                                            <p><strong>شرح وظیفه:</strong> {r.description || '---'}</p>
                                                                            <p><strong>ایجاد:</strong> {r.createDatePersian} | <strong>سررسید:</strong> {r.dueDatePersian}</p>
                                                                            <p><strong>وضعیت:</strong> {r.statusText} | <strong>مدت زمان:</strong> {r.duration}</p>
                                                                            {r.customerName && r.customerName !== '---' && (
                                                                                <p>
                                                                                    <strong>مشتری:</strong> {r.customerName}
                                                                                    {r.customerPhone && ` | تلفن: ${r.customerPhone}`}
                                                                                    {r.customerAddress && ` | آدرس: ${r.customerAddress}`}
                                                                                </p>
                                                                            )}

                                                                            {r.comments.length > 0 && (
                                                                                <>
                                                                                    <h6>مکاتبات ({r.comments.length})</h6>
                                                                                    <table className="table table-sm table-bordered" >
                                                                                        <thead><tr><th>کاربر</th><th>متن</th><th>تاریخ</th></tr></thead>
                                                                                        <tbody>
                                                                                            {r.comments.map(c => (
                                                                                                <tr key={c.id}>
                                                                                                    <td>{c.userName}</td>
                                                                                                    <td>{c.content}</td>
                                                                                                    <td>{c.createdDatePersian}</td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </>
                                                                            )}

                                                                            {r.documents.length > 0 && (
                                                                                <>
                                                                                    <h6 className="mt-3">مدارک ({r.documents.length})</h6>
                                                                                    <table className="table table-sm table-bordered" >
                                                                                        <thead><tr><th>نام فایل</th><th>نوع</th><th>توضیح</th><th>تاریخ</th></tr></thead>
                                                                                        <tbody>
                                                                                            {r.documents.map(d => (
                                                                                                <tr key={d.id}>
                                                                                                    <td>{d.fileName}</td>
                                                                                                    <td>{d.documentType}</td>
                                                                                                    <td>{d.description}</td>
                                                                                                    <td>{d.uploadDatePersian}</td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </>
                                                                            )}

                                                                            {r.comments.length === 0 && r.documents.length === 0 && (
                                                                                <p className="text-muted">هیچ کامنت یا مدرکی برای این وظیفه ثبت نشده است.</p>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="card-inner"><div className="alert alert-info">داده‌ای یافت نشد.</div></div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <Footer key="footer" />
        ];


        return contents;
    }
}